import axios from './custom-axios';
import { urlRailway } from '../constants/endpoint';

export async function getNotes() {
  try {
    let id = localStorage.getItem('id');
    const response = await axios.get(
      `${ urlRailway }note/search/${ id }`
    );
    return response.data.notes;
  } catch (error) {
    console.error(error);
  }
}

export async function searchNotes(value) {
    try {
      let id = localStorage.getItem('id');
      const response = await axios.get(
        `${ urlRailway }note/search/${id}/${value}`
      );
      return response.data.notes;
    } catch (error) {
      console.error(error);
    }
  }

export async function addNote() {
    try {
      let id = localStorage.getItem('id');
  
      var noteForm = new FormData();
      noteForm.append("title", "");
      noteForm.append("note", "");
      noteForm.append("color", "bg-zinc-800");
      noteForm.append("userId", id);
  
      const response = await axios.post(
        `${ urlRailway }note/add`,
        noteForm,
        {
          "Content-Type": "multipart/form-data",
        }
      );
      return response.data.note;
    } catch (error) {
      console.error(error);
    }
}

export async function updateNote(id, title, note, color) {
    try {
      
        var noteForm = new FormData();
        noteForm.append("title", title);
        noteForm.append("note", note);
        noteForm.append("color", color);  
        noteForm.append("noteId", id);
  
        const response = await axios.put(
          `${ urlRailway }note/modify`,
            noteForm,
            {
            "Content-Type": "multipart/form-data",
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export async function deleteNote(id) {
    try {
      const response = await axios.delete(
        `${ urlRailway }note/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
